module.exports = __webpack_public_path__ + "img/cloud1_1.54a92bcb.png";